module.exports = __webpack_public_path__ + "static/media/arrow-right-blue-hover.f68528bf.svg";